"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = formatNumber;

function formatNumber(value, wholeNumbers) {
  if (wholeNumbers) {
    return parseFloat(value).toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }

  return parseFloat(value).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}